import React, { useContext, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { DiffContext } from '../../contexts/DiffContext/DiffContext';
import { getDiff } from '../../contexts/DiffContext/diffContextHelper';
import './DiffDisplay.css';
import { makeStyles } from '@material-ui/core';
import { convertImageSrc } from './ImageBlot'
import { MarketsContext } from '../../contexts/MarketsContext/MarketsContext'
import _ from 'lodash'
import { useHistory } from 'react-router'
import { handleRichTextLinkClick } from '../../utils/windowUtils'

const useStyles = makeStyles(
  () => {
    return {
      diffContainer: {
        '& p': {
          width: '100%'
        },
        '& div': {
          width: '100%'
        },
        '& span': {
          width: '100%'
        }
      }
    }
  }
)

function DiffDisplay(props) {
  const classes = useStyles();
  const ref = useRef(null);
  const history = useHistory();
  const { id, isWhiteText = false } = props;
  const [diffState] = useContext(DiffContext);
  const [marketsState, , tokensHash] = useContext(MarketsContext);
  const diff = marketsState.initializing || _.isEmpty(tokensHash) ? undefined : getDiff(diffState, id);

  useEffect(() => {
    if (ref.current !== null) {
      if (diff) {
        ref.current.innerHTML = diff.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, function (match, capture) {
          const newSrc = convertImageSrc(capture) || capture;
          return `<img src="${newSrc}">`;
        });
      }
    }
    return () => {
    };
  }, [ref, diff, id, tokensHash]);

  if (!diff) {
    return React.Fragment;
  }

  return (
    <div>
      {/* B-all-472: same color contract as QuillEditor2 - black unless the surface behind is
          dark (isWhiteText). Inheriting the dark theme's white made diffs unreadable on the
          light comment and description cards. */}
      <div ref={ref} className={classes.diffContainer} style={{color: isWhiteText ? 'white' : 'black'}}
           onClick={(event) => handleRichTextLinkClick(event, history)}/>
    </div>
  );
}

DiffDisplay.propTypes = {
  id: PropTypes.string.isRequired,
  isWhiteText: PropTypes.bool
};

export default DiffDisplay;
